import { combineReducers } from "redux";
import commonReducer from "@frameworks/web/redux/feature/Markets/Common/Reducers/commonReducer";
import drivingMarketParamsReducer from "../drivingMarketParams";
import mostActiveByVolumeReducer from "./mostActiveByVolume";
export default combineReducers({
    reducersData: mostActiveByVolumeReducer,
    commonData: commonReducer,
    paramsData: drivingMarketParamsReducer,
});
